module.exports = __webpack_public_path__ + "media/3_18.f3a405a5.wav";